module.exports = __webpack_public_path__ + "img/baoxian.2216d2b3.png";